import {computed} from "mobx";
import {StageDomainModel} from "./stage-domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class StageViewModel extends BaseViewModel {
  domainModel: StageDomainModel;

  constructor(domainModel: StageDomainModel){
    super(domainModel);

    this.domainModel = domainModel;
  }

  @computed get shortName(): String {
    return this.domainModel.shortName;
  }

  @computed get isCurrent(): String {
    return this.domainModel.isCurrent;
  }

  @computed get scoreText(): String {
    return this.domainModel.scoreText;
  }
}
